export default {
    token: '',
    email: "",
    name: "",
    tenant: "",
    hasLogged: false,
    permissionRoutes: [],
    originBackoffice: false
}